<div class="community-message-detail container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h1 class="h3 mb-0">{{ t('community.messages.detail_title') }}</h1>
    <a class="btn btn-outline-secondary btn-sm" [routerLink]="backLink()">← {{ t('community.messages.back_to_list') }}</a>
  </header>

  @if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else if (error(); as key) {
    <div class="alert alert-warning">{{ t(key) }}</div>
  } @else if (message(); as m) {
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2 class="h5 mb-0">{{ m.subject }}</h2>
      <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="busy()" (click)="toggleArchive()">
        {{ m.is_archived ? t('community.messages.unarchive') : t('community.messages.archive') }}
      </button>
    </div>

    @for (item of fullThread(); track item.id) {
      <div class="card mb-2" [class.community-message-detail__mine]="isMine(item)">
        <div class="card-body py-2">
          <div class="d-flex align-items-center gap-2 mb-2">
            <app-community-avatar [user]="item.sender" [size]="32" />
            <div class="flex-grow-1">
              <div>
                <a [routerLink]="memberLink(item.sender.id)">{{ item.sender.full_name || item.sender.username }}</a>
                <span class="text-muted small"> → </span>
                <a [routerLink]="memberLink(item.recipient.id)">{{ item.recipient.full_name || item.recipient.username }}</a>
              </div>
              <div class="text-muted small">{{ item.created_at | date:'medium' }}</div>
            </div>
          </div>
          <div class="community-message-detail__content">{{ item.content }}</div>
        </div>
      </div>
    }

    @if (replyOpen()) {
      <div class="card">
        <div class="card-body">
          @if (replyError(); as key) {
            <div class="alert alert-danger py-2">{{ t(key) }}</div>
          }
          <textarea class="form-control mb-2" rows="5" [(ngModel)]="replyDraft" [placeholder]="t('community.messages.write_reply')"></textarea>
          <div class="d-flex gap-2">
            <button type="button" class="btn btn-primary btn-sm" [disabled]="replyBusy() || !replyDraft.trim()" (click)="submitReply()">
              @if (replyBusy()) { <span class="spinner-border spinner-border-sm me-1" role="status"></span> }
              {{ t('community.messages.send') }}
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="replyBusy()" (click)="cancelReply()">
              {{ t('community.threads.cancel') }}
            </button>
          </div>
        </div>
      </div>
    } @else {
      <button type="button" class="btn btn-primary btn-sm" (click)="openReply()">{{ t('community.messages.reply') }}</button>
    }
  }
</div>
